import * as React from 'react';
import { useLocation } from 'react-router';

import { ImmutableEntity } from '@uncinc/react-drupal-core/types';
import TaxonomyThemeParent from './Parent';
import TaxonomyThemeChild from './Child';
import TaxonomyThemeFaqPage from './Faq';
import { TaxonomyTheme } from '../../../../types/uncinc_profile/taxonomy';
import { FAQ_BASE_PATH } from '../../../../config/constants';

interface ThemeProps {
  entity: ImmutableEntity<TaxonomyTheme>;
}

const TaxonomyThemeWrapper: React.FC<ThemeProps> = ({ entity }) => {
  const theme = entity.toJS();
  const parent = theme.parent[0]?.target_id;

  const location = useLocation();
  const { pathname } = location;
  const pathStart = pathname?.split('/')[1];

  // If the path starts with the FAQ_BASE_PATH we render the faq page.
  if (pathStart === FAQ_BASE_PATH) {
    return <TaxonomyThemeFaqPage entity={entity} />;
  }

  // If the taxonomy has a parent, it must be a child.
  if (parent) {
    return <TaxonomyThemeChild entity={entity} />;
  }

  // If the taxonomy has no parent, itself must be a parent.
  return <TaxonomyThemeParent entity={entity} />;
};

export default TaxonomyThemeWrapper;
